export const SET_LOCALE = 'page/SET_LOCALE';
export const TOGGLE_LOCALE = 'page/TOGGLE_LOCALE';
